// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3l_2Z","balanceDisclaimer":"posDashboard_balanceDisclaimer__3s8Hv"};